import Vue from "vue";
import moment from "moment";
import { Component, Prop, Watch } from "vue-property-decorator";
import { CongeDto } from "../../../../dto/GenApi.iNotPaie.Dto/CongeDto";

@Component
export default class DetailAbsence extends Vue {
	public absencePeriode: CongeDto[] = [];

	@Prop()
	public currentDate: Date = new Date();

	@Prop()
	public listAbsenceSalarie: CongeDto[] = [];

	@Prop()
	public firstDate: Date = new Date();

	@Prop()
	public lastDate: Date = new Date();

	@Watch("listAbsenceSalarie")
	public setAbsence(): void {
		this.absencePeriode = [];

		for (let i = 0; i < this.listAbsenceSalarie.length; i++) {
			const abs = this.listAbsenceSalarie[i];

			if (moment.utc(abs.Date).isBetween(this.firstDate, this.lastDate)) {
				if (this.absencePeriode.filter(a => a.Id == abs.Id).length == 0) {
					this.absencePeriode.push(abs);
				}
			}
		}

		this.$forceUpdate();
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/absences/detailAbsence/detailAbsence.ts